module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_is-object.js
// module id = 88
// module chunks = 1